import React from 'react';
import './InfiniteScrollLoader.css';

const InfiniteScrollLoader = ({ hasMore }) => {
    if (!hasMore) return (
        <div className='isl-end'>
            <span className='isl-end-line'></span>
            <span className='isl-end-text'>You're all caught up</span>
            <span className='isl-end-line'></span>
        </div>
    );

    return (
        <div className='isl-container'>
            <div className='isl-dot'></div>
            <div className='isl-dot'></div>
            <div className='isl-dot'></div>
        </div>
    );
};

export default InfiniteScrollLoader;